export default "__VITE_ASSET__CNHH94lX__"